import { HttpErrorResponse } from '@angular/common/http';
import { Country } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getCountries = createAction('[CountryFilters] Get Countries');

export const getCountriesSuccess = createAction('[CountryFilters] Get Countries Success', props<{ countries: Country[] }>());

export const getCountriesFailure = createAction('[CountryFilters] Get Countries Failure', props<{ error: HttpErrorResponse }>());

export const fetchCountries = createAction('[CountryFilters] Fetch Countries');

export const searchCountries = createAction('[CountryFilters] Get Countries With Search', props<{ searchText: string; delay: number }>());

export const searchCountriesSuccess = createAction(
    '[CountriesFilters] Get Countries With Search Success',
    props<{ countries: Country[]; searchText: string | null }>()
);

export const isLoadingCountries = createAction('[CountryFilters] Loading Countries');
